<template>
    <div class="title-block">
        <div class="title-block__title">
            Добавить группу
        </div>
    </div>
    <form class="form-narrow">
        <div class="mb-4">
            <div class="form-label">Введите названия группы</div>
            <input type="text" class="form-control" name="group" id="group">
        </div>
        <div class="mb-4">
            <div class="form-label">Введите имя руководителя</div>
            <input type="text" class="form-control" name="name" id="name">
        </div>
        <div class="mb-4">
            <div class="form-label">Введите электронную почту</div>
            <input type="email" class="form-control" name="email" id="email">
        </div>
        <div class="mb-4">
            <div class="form-label">Установите пароль</div>
            <input type="password" class="form-control" name="password" id="password">
        </div>
        <div class="mb-4">
            <div class="form-label">Повторите пароль</div>
            <input type="passwordConfirm" class="form-control" name="passwordConfirm" id="passwordConfirm">
        </div>
        <div class="d-flex align-items-stretch py-3">
            <button type="button" class="btn btn-lg btn-primary flex-grow-1 me-3">
                Сохранить
            </button>
            <a href="/access" type="button" class="btn btn-lg btn-outline-dark flex-grow-1">
                Отменить
            </a>
        </div>
    </form>
</template>

<script>
export default {
    name: "AccessAddGroup"
};
</script>
